import React, { memo, useState } from 'react';
import { GridHeaderTitle } from '@components-clean/core/grid/grid.interface';
import AttendeesGrid from '@pages-clean/risk-assessment/monitoring-toolkit/manage-reviews-tab/attendees-grid';
import RiskReviewsGrid from '@pages-clean/risk-assessment/monitoring-toolkit/manage-reviews-tab/risk-reviews-grid';
import { NullableStudy } from '@contexts/local-state-context';
import { useTranslation } from '@hooks/index';

interface ManageReviewsTabProps {
    studyRef: string;
    studyNumber: string;
    study?: NullableStudy;
}

enum ManageReviewsChip {
    RiskReviews = 1,
    Attendees = 2,
}

const ManageReviewsTab = ({ studyRef, studyNumber, study }: ManageReviewsTabProps) => {
    const { t } = useTranslation('ram', { keyPrefix: 'monitoringToolkit' });
    const [chip, setChip] = useState<ManageReviewsChip>(ManageReviewsChip.RiskReviews);

    const chipHeaders: GridHeaderTitle[] = [
        { id: ManageReviewsChip.RiskReviews, label: t('riskReviewsChip') },
        { id: ManageReviewsChip.Attendees, label: t('attendeesChip') },
    ];

    return (
        <div className="k-h-full k-d-flex k-flex-col" style={{ minHeight: 0 }}>
            {chip === ManageReviewsChip.RiskReviews && (
                <RiskReviewsGrid
                    id={studyRef}
                    studyNumber={studyNumber}
                    chipHeaders={chipHeaders}
                    selectedChipHeader={chip}
                    onChipHeaderSelected={(selected) => setChip(selected)}
                    study={study}
                />
            )}
            {chip === ManageReviewsChip.Attendees && (
                <AttendeesGrid
                    id={studyRef}
                    studyNumber={studyNumber}
                    chipHeaders={chipHeaders}
                    selectedChipHeader={chip}
                    onChipHeaderSelected={(selected) => setChip(selected)}
                />
            )}
        </div>
    );
};

export default memo(ManageReviewsTab);
